import Permission from 'constants/Permissions'

const permissionLabels: Record<Permission, string> = {
  [Permission.AccountingErpConnect]: 'manage external sources',
  [Permission.AccountingErpEdit]: 'edit external sources',
  [Permission.AccountingErpRead]: 'view external sources',
  [Permission.AccountingMappingDelete]: 'delete accounting mappings',
  [Permission.AccountingMappingRead]: 'view accounting mappings',
  [Permission.AccountingMappingUpsert]: 'create or update accounting mappings',
  [Permission.AccountingReportRead]: 'view accounting reports',
  [Permission.PrincipalMarketAnalysisRead]: 'view or run principal market analyses',
  [Permission.PrincipalMarketAnalysisWrite]: 'create or update principal market analyses',
  [Permission.SettingAuditLogsRead]: 'view audit logs',
  [Permission.SettingCategoryAdd]: 'add categories',
  [Permission.SettingCategoryRead]: 'view categories',
  [Permission.SettingConfigRead]: 'view accounting or tax settings',
  [Permission.SettingConfigEdit]: 'edit accounting or tax settings',
  [Permission.SettingContactDelete]: 'delete contacts',
  [Permission.SettingContactRead]: 'view contacts',
  [Permission.SettingContactUpsert]: 'create or update contacts',
  [Permission.SettingEntityAdd]: 'add legal entities',
  [Permission.SettingEntityDelete]: 'delete legal entities',
  [Permission.SettingEntityRead]: 'view legal entities',
  [Permission.SettingOrgEdit]: 'edit organization settings',
  [Permission.SettingOrgRead]: 'view organization settings',
  [Permission.SettingPricingEdit]: 'edit pricing settings',
  [Permission.SettingPricingRead]: 'view pricing',
  [Permission.SettingSpamTokenAdd]: 'add spam tokens',
  [Permission.SettingSpamTokenEnableAutoIngestion]: 'enable spam token auto-ingestion',
  [Permission.SettingSpamTokenDelete]: 'delete spam tokens',
  [Permission.SettingSpamTokenRead]: 'view spam tokens',
  [Permission.SettingTeamDelete]: 'delete team members',
  [Permission.SettingTeamRead]: 'view team members',
  [Permission.SettingTeamUpsert]: 'manage team members',
  [Permission.TransactionBulkPreviewRead]: 'view this transaction data',
  [Permission.TransactionCustomFieldsDelete]: 'delete custom fields',
  [Permission.TransactionCustomFieldsRead]: 'view custom fields',
  [Permission.TransactionCustomFieldsUpsert]: 'create or update custom fields',
  [Permission.TransactionDashboardRead]: 'view the transaction dashboard',
  [Permission.TransactionDataAddAttachment]: 'add attachments to transactions',
  [Permission.TransactionDataEdit]: 'edit transaction data',
  [Permission.TransactionDataRead]: 'view transaction data',
  [Permission.TransactionErpSync]: 'sync transactions with external sources',
  [Permission.TransactionJournalEntryDownload]: 'download journal entries',
  [Permission.TransactionJournalEntryRead]: 'view journal entries',
  [Permission.TransactionRateEdit]: 'edit transaction rates',
  [Permission.TransactionRateDelete]: 'delete transaction rates',
  [Permission.TransactionRateRead]: 'view transaction rates',
  [Permission.TransactionRuleDelete]: 'delete rules',
  [Permission.TransactionRuleRead]: 'view rules',
  [Permission.TransactionRuleUpsert]: 'create or update rules',
  [Permission.TransactionSensitiveDataRead]: 'view sensitive data',
  [Permission.TransactionSourceDelete]: 'delete transaction sources',
  [Permission.TransactionSourceRead]: 'view transaction sources',
  [Permission.TransactionSourceUpsert]: 'create or update transaction sources',
  [Permission.TransactionTokenDownload]: 'download transaction tokens',
  [Permission.TransactionTokenEdit]: 'edit transaction tokens',
  [Permission.VoucherApprove]: 'approve vouchers',
  [Permission.VoucherSubmit]: 'submit vouchers',
  [Permission.VoucherCreate]: 'create vouchers',
  [Permission.VoucherDelete]: 'delete vouchers',
  [Permission.VoucherEdit]: 'create or update vouchers',
  [Permission.VoucherReviewerEdit]: 'edit vouchers',
  [Permission.VoucherAudit]: 'audit vouchers',
  [Permission.VoucherCertify]: 'certify vouchers',
  [Permission.VoucherRework]: 'rework vouchers',
  [Permission.VoucherSync]: 'sync vouchers',
  [Permission.VoucherView]: 'view vouchers',
  [Permission.VoucherWithdraw]: 'withdraw vouchers',
  [Permission.GeneralAllRead]: 'view this data',
  [Permission.SystemIngestionAdmin]: 'manage ingestion settings',
  [Permission.SystemSettingAdmin]: 'manage system settings',
}

const getDefaultPermissionRequiredLabel = (permissionName: Permission) =>
  `You do not have permission to ${permissionLabels[permissionName]}`

export default getDefaultPermissionRequiredLabel
